interface SystemMessagePillProps {
  body: string;
}

/**
 * Centered notice rendered for `sender=null` rows — backend posts these for
 * room-membership lifecycle events ("X added Y to the group", "X left the
 * group"). Visually mimics the day-separator pill so the timeline reads
 * cleanly without any avatar/bubble chrome.
 */
export function SystemMessagePill({ body }: SystemMessagePillProps) {
  return (
    <div className="my-3 flex select-none justify-center">
      <span className="max-w-[80%] border border-gray-200 bg-white px-3 py-1 text-center text-[11px] text-gray-500">
        {body}
      </span>
    </div>
  );
}
